var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 0H1.96875C0.881439 0 0 0.881439 0 1.96875V4.59375C0 5.68106 0.881439 6.5625 1.96875 6.5625H4.59375C5.68106 6.5625 6.5625 5.68106 6.5625 4.59375V1.96875C6.5625 0.881439 5.68106 0 4.59375 0Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 0H10.4062C9.31894 0 8.4375 0.881439 8.4375 1.96875V4.59375C8.4375 5.68106 9.31894 6.5625 10.4062 6.5625H13.0312C14.1186 6.5625 15 5.68106 15 4.59375V1.96875C15 0.881439 14.1186 0 13.0312 0Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 8.4375H1.96875C0.881439 8.4375 0 9.31894 0 10.4062V13.0312C0 14.1186 0.881439 15 1.96875 15H4.59375C5.68106 15 6.5625 14.1186 6.5625 13.0312V10.4062C6.5625 9.31894 5.68106 8.4375 4.59375 8.4375Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 8.4375H10.4062C9.31894 8.4375 8.4375 9.31894 8.4375 10.4062V13.0312C8.4375 14.1186 9.31894 15 10.4062 15H13.0312C14.1186 15 15 14.1186 15 13.0312V10.4062C15 9.31894 14.1186 8.4375 13.0312 8.4375Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid-view.00ba979e8ab115653f6bbca3c49ca0db.svg";
export { ForwardRef as ReactComponent };